import { generatePath } from 'react-router-dom'
import { INSIGHTS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Workspace } from 'types'
import { BarGroup3 } from 'blaze-ui/icons/24'

interface Props {
  workspace: Workspace
  onPress: () => void
}

export const NavMenuInsightsItem = ({ workspace, onPress }: Props) => {
  const to = generatePath(INSIGHTS_PATH, { workspaceId: workspace.id })

  return <NavMenuItem icon={BarGroup3} activeIcon={BarGroup3} to={to} onPress={onPress} label="Insights" />
}
